export default __webpack_public_path__ + "static/Pablo_Lapadula_SMALL-9d94e6a574ec924fcf53a02f9c909c03.png";